import { render, staticRenderFns } from "./XButton.vue?vue&type=template&id=a8ccec92&scoped=true&"
import script from "./XButton.vue?vue&type=script&lang=js&"
export * from "./XButton.vue?vue&type=script&lang=js&"
import style0 from "./XButton.vue?vue&type=style&index=0&id=a8ccec92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ccec92",
  null
  
)

export default component.exports